import { FC } from "react";

import { MarkdownDiv } from "@tsmono/react/components";

import type { ToolSearchNamespaceEntry } from "./tool";
import styles from "./ToolSearchView.module.css";

interface ToolSearchViewProps {
  namespaces: ToolSearchNamespaceEntry[];
}

/**
 * Renders a Codex `tool_search` catalog: each namespace lists its tools, with
 * each tool a collapsible `<details>` — the signature in the summary, the
 * description (markdown) in the body. Compact by default; expand for detail.
 */
export const ToolSearchView: FC<ToolSearchViewProps> = ({ namespaces }) => {
  return (
    <div className={styles.catalog}>
      {namespaces.map((namespace, nsIdx) => (
        <div key={`ns-${nsIdx}`} className={styles.namespace}>
          {namespace.name ? (
            <div>
              <span className={styles.namespaceName}>{namespace.name}</span>
              {namespace.description ? (
                <span className={styles.namespaceDescription}>
                  {" — "}
                  {namespace.description}
                </span>
              ) : null}
            </div>
          ) : null}
          {namespace.tools.map((tool, toolIdx) =>
            tool.description ? (
              <details key={`tool-${toolIdx}`} className={styles.tool}>
                <summary className={styles.summary}>
                  <code>{tool.signature}</code>
                </summary>
                <MarkdownDiv
                  className={styles.description}
                  markdown={tool.description}
                />
              </details>
            ) : (
              <div key={`tool-${toolIdx}`} className={styles.toolNoDetails}>
                <code>{tool.signature}</code>
              </div>
            )
          )}
        </div>
      ))}
    </div>
  );
};
